export class SapObjectStats {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "rowCount",
            "baseName": "rowCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "estBytes",
            "baseName": "estBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return SapObjectStats.attributeTypeMap;
    }
    constructor() {
    }
}
